"use client";

import { Card, CardContent } from "@/components/shadcn/card";
import { isSocialEventsEnabled } from "@/lib/feature-flags";
import { cn } from "cn";
import { Crown, Presentation, Settings, Trophy, User } from "lucide-react";
import { useTranslations } from "next-intl";
import Link from "next/link";
import { usePathname } from "next/navigation";

export default function ProfileNavCard() {
    const t = useTranslations("profile");
    const pathname = usePathname();
    const navItems = [
        { href: "/kullanici", label: t("profile"), icon: User },
        {
            href: "/kullanici/siniflar",
            label: t("classes"),
            icon: Presentation,
        },
        ...(isSocialEventsEnabled()
            ? [
                  {
                      href: "/kullanici/social",
                      label: t("social"),
                      icon: Trophy,
                  },
              ]
            : []),
        {
            href: "/kullanici/ayarlar",
            label: t("accountSettings"),
            icon: Settings,
        },
        {
            href: "/kullanici/abonelik",
            label: t("premiumSettings"),
            icon: Crown,
        },
    ];

    return (
        <Card>
            <CardContent>
                <nav aria-label={t("navLabel")}>
                    <ul className="flex flex-col gap-1">
                        {navItems.map((item) => {
                            const Icon = item.icon;
                            const isActive =
                                pathname === item.href ||
                                (item.href !== "/kullanici" &&
                                    pathname.startsWith(`${item.href}/`));

                            return (
                                <li key={item.href}>
                                    <Link
                                        href={item.href}
                                        className={cn(
                                            "hover:bg-accent hover:text-accent-foreground flex items-center gap-2 rounded-md px-2 py-1.5 transition-colors",
                                            isActive
                                                ? "bg-accent text-primary"
                                                : "text-foreground",
                                        )}
                                    >
                                        <Icon className="size-3.5" />
                                        <span className="min-w-0 flex-1 truncate">
                                            {item.label}
                                        </span>
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </nav>
            </CardContent>
        </Card>
    );
}
